import { createFeatureSelector, createSelector } from '@ngrx/store';
import { get as _get } from 'lodash';

import { ToastModel } from '../models/kyd-partial-household.model';
import { KYD_PHH_KEY, KydPartialHouseholdState } from './kyd-partial-household.reducer';

export const getKydPhhState = createFeatureSelector<KydPartialHouseholdState>(KYD_PHH_KEY);

export const isKydPhhLoading = createSelector(
  getKydPhhState,
  (state: KydPartialHouseholdState) => state.loading
);

export const getKydActionStatus = createSelector(
  getKydPhhState,
  (state: KydPartialHouseholdState) => state.actionStatus
);

export const getKydRecentAction = createSelector(getKydActionStatus, status =>
  _get(status, 'recentAction')
);

export const getKydToastMessage = createSelector(getKydActionStatus, status => {
  const toast: ToastModel = {
    type: _get(status, 'toastType'),
    body: _get(status, 'toastBody')
  };
  return toast;
});

export const kydPartialHouseholdQuery = {
  getKydPhhState,
  isKydPhhLoading,
  getKydActionStatus,
  getKydRecentAction,
  getKydToastMessage
};
